<template>
  <div class="input-element" :class="{ boxed: boxed }">
    <span v-if="supportingText" class="text-muted text-xs supporting-text" v-html="supportingText"></span>
    <input
      ref="inputField"
      :pattern="pattern"
      :type="typeIsSwitch ? inputTypeSwitch : inputType"
      :id="name"
      :value="value"
      :placeholder="placeholder"
      @blur="$emit('blur')"
      @input="$emit('input', $event.target.value)"
      @focus="$emit('focus')"
      :class="{
        invalid: invalidInput,
        valid: validInput,
        'switch-type': typeIsSwitch,
        'hidden-text': visibilityToggle == true,
        'padding-right': typeIsSwitch || toggleVisibility
      }"
      :style="[cssProps, { paddingRight: inputButtonSize + 'px' }]"
      :disabled="isDisabled"
      :readonly="isReadonly"
      :required="isRequired"
      :autocomplete="autoComplete"
      :list="list"
    />
    <label :style="cssProps" :for="name" :class="{ invalid: invalidInput, valid: validInput }">{{ label }}</label>
    <!-- <div>{{labelLength}}</div> -->
    <div v-if="typeIsSwitch || toggleVisibility" @click="switchVisibility()" class="visibility-switch">
      <div v-show="inputTypeSwitch == 'password' || visibilityToggle == true">
        <i class="fa-light fa-eye"></i>
      </div>
      <div v-show="inputTypeSwitch == 'text' || visibilityToggle == false">
        <i class="fa-light fa-eye-slash"></i>
      </div>
    </div>

    <button
      ref="inputButton"
      type="button"
      class="option-btn"
      :class="btnVisible ? 'always-visible' : ''"
      v-if="optionBtn"
      @click="$emit('option-btn-clicked'), $refs.inputField.focus()"
    >
      {{ btnText }}
    </button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      typeIsSwitch: false,
      inputTypeSwitch: "password",
      visibilityToggle: false,
      inputButtonSize: null
    };
  },
  props: {
    value: {
      // required: true,
      type: [Number, String]
    },
    name: {
      required: true,
      type: String
    },
    placeholder: String,
    label: String,

    activeColor: {
      type: String,
      default: "var(--charcoal)"
    },
    textColor: {
      type: String,
      default: "var(--charcoal)"
    },
    labelBG: {
      type: String,
      default: "var(--background-white)"
    },
    inputType: {
      type: String
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isReadonly: {
      type: Boolean,
      default: false
    },
    focusInputField: {
      type: Boolean,
      default: false
    },
    invalidInput: { type: Boolean },
    validInput: { type: Boolean },
    isRequired: {
      type: Boolean,
      default: false
    },
    optionBtn: {
      type: Boolean,
      default: false
    },
    btnVisible: {
      type: Boolean,
      default: false
    },
    btnText: {
      type: String
    },
    autoComplete: {
      type: String,
      default: "on"
    },
    pattern: {
      type: String
    },
    toggleVisibility: {
      type: Boolean
    },
    list: {
      type: String,
      default: null
    },
    btnPadding: {
      type: Boolean
    },
    boxed: {
      type: Boolean
    },
    supportingText: {
      type: String
    }
  },
  computed: {
    cssProps() {
      return {
        "--active-color": this.activeColor,
        "--label-bg-color": this.labelBG,
        "--text-color": this.textColor
      };
    }
  },
  methods: {
    getInputButtonSize() {
      return this.$refs.inputButton.clientWidth;
    },
    switchVisibility() {
      this.inputTypeSwitch = this.inputTypeSwitch === "password" ? "text" : "password";
      this.visibilityToggle = !this.visibilityToggle;
    },
    focus: function() {
      this.$refs.inputField.focus();
    }
  },
  mounted() {
    if (this.btnPadding || this.btnVisible) {
      this.inputButtonSize = this.getInputButtonSize();
    }
    if (this.toggleVisibility) {
      this.visibilityToggle = true;
    }
    if (this.inputType === "switch") {
      this.typeIsSwitch = true;
    }
    if (this.focusInputField == true) {
      this.$refs.inputField.focus();
    }
  },
  created() {
    if (this.toggleVisibility) {
      this.visibilityToggle = true;
    }
  },
  watch: {
    btnText: {
      handler: function() {
        this.$nextTick(() => {
          this.inputButtonSize = this.getInputButtonSize();
        });
      }
    }
  }
};
</script>

<style lang="less">
.input-element {
  position: relative;
  display: flex;
  flex-flow: column-reverse;
  //   margin-bottom: 1em;

  label,
  input {
    transition: all 0.2s;
    touch-action: manipulation;
  }
  input {
    border-radius: 0;
    overflow-x: auto; // Test - if an input field has a loooong value
    font-size: 14px;
    //   border: 0;
    //   border: 1px solid #ccc; // !!With full border
    border: none; // !!With only bottom border
    border-bottom: 1px solid #ccc; // !!With only bottom border
    font-family: inherit;
    -webkit-appearance: none;
    //   border-radius: 4px; // !!With full border
    padding: 10px 0;

    //   padding: 10px ;
    cursor: text;
    color: var(--text-color);
    font-weight: 500;
    background-color: inherit;

    &::placeholder {
      opacity: 0;
    }
  }
  .switch-type {
    padding-right: 40px;
  }
  .hidden-text {
    text-security: disc;
    -webkit-text-security: disc;
    -mox-text-security: disc;
  }

  // input::placeholder{
  //   opacity: 0;
  // }

  // input:focus::placeholder{
  //     opacity: 1;
  // }

  input:focus {
    outline: 0;
    //   border: 1px solid #666; // !!With full border
    border: none; // !!With only bottom border
    border-bottom: 1px solid #666; // !!With only bottom border
    border-color: var(--active-color);
    color: var(--active-color);

    &.valid {
      border-color: var(--success-green);
    }
    &.invalid {
      border-color: var(--danger-red);
    }

    &::placeholder {
      opacity: 1;
      color: #8f979c;
    }
  }
  label {
    //   text-transform: uppercase;
    //   letter-spacing: 0.05em;
    color: #8f979c;
    font-weight: 500;
  }
  input:placeholder-shown + label {
    cursor: text;
    //   max-width: 66.66%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    transform-origin: 0 0;
    transform: translate(0px, 40px) scale(1);
    //   transform: translate(0px, 38px) scale(1);
  }

  ::-webkit-input-placeholder {
    opacity: 0 !important; //for some reason theese have to be important?
    transition: inherit;
  }
  input:focus::-webkit-input-placeholder {
    opacity: 1 !important; //for some reason theese have to be important?
  }
  input:not(:placeholder-shown) + label,
  input:focus + label,
  input:-webkit-autofill + label {
    //   transform: translate(10px, 21px) scale(.8); //With full border!!
    transform: translate(0px, 12px) scale(0.8); // With only bottom border
    transform-origin: 0 0;
    width: max-content;
    padding: 0 2px 0 0;
    //   padding: 0 2px  ;
    color: inherit;
    color: #8f979c;
    font-weight: bold;
    //   background-color: #f2f2f2; // With full border!!
    //   background-color: var(--label-bg-color); // With full border!!

    cursor: pointer;

    &.valid {
      color: #28a745;
    }
    &.invalid {
      color: var(--danger-red);
    }
  }
  // input:not(:placeholder-shown) + input:not(:focus) {

  // }

  input:disabled,
  input[readonly] {
    // background-color: #e9ecef;
    // border-bottom: none !important;
    opacity: 0.5;
  }
  input:disabled + label,
  input[readonly] + label {
    opacity: 0.5;
  }

  .invalid {
    border-color: var(--danger-red);
    //   color: var(--danger-red);
  }
  .valid {
    border-color: #28a745;
    //   color: #28a745;
  }

  .option-btn {
    opacity: 0;
    border: none;
    position: absolute;
    top: 10px;
    // bottom: -20px;
    right: 0;
    background: inherit;
    color: var(--orange-web);
    font-size: 12px;
  }

  .always-visible {
    opacity: 1;
    top: 50%;
  }
  input:focus {
    ~ button {
      opacity: 1;
    }
  }
  //Removing the styling from chrome autofill
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0px 1000px #ffffff inset !important;
  }
  .visibility-switch {
    div {
      cursor: pointer;
      position: absolute;
      top: 50%;
      display: flex;
      align-items: center;
      right: 20px;
      transform: translateY(50%);
    }
  }

  .padding-right {
    padding-right: 40px;
  }
  .supporting-text {
    padding-left: 12px;
  }

  &.boxed {
    input {
      border: 1px solid #ccc; // !!With full border
      border-radius: 3px; // !!With full border
      padding-left: 12px;
      &::placeholder {
        opacity: 0;
      }
    }

    input:focus {
      border: 1px solid var(--charcoal); // !!With full border
    }
    input:focus + label {
      color: var(--charcoal);
    }
    input:placeholder-shown + label {
      transform: translate(12px, 40px) scale(1);
    }

    input:not(:placeholder-shown) + label,
    input:focus + label,
    input:-webkit-autofill + label {
      transform: translate(10px, 21px) scale(0.8); //With full border!!
      background-color: #f2f2f2; // With full border!!
      background-color: var(--label-bg-color); // With full border!!
      padding: 0 4px;
    }
    
    input:disabled + label,
    input[readonly] + label {
      opacity: 1; // Avoid transparent label when disabled or readonly;
    }
  }
}
</style>
